<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_allacciatura') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column">
        <template v-for="(all, index) in mod.allacci">
          <div :key="index">
            <b-button
              v-if="index != 0 || !orderInfoMandatory"
              type="is-primary"
              inverted
              :disabled="disabledbool"
              class="linkred"
              @click="removeallcia(index)"
            >
              {{ $translate('remove_allacci') | capitalize }}
              <b-icon icon="minus-circle" size="is-small" />
            </b-button>
            <b-field
              :type="{ 'is-danger': errors.has('allprim') }"
              :message="errors.first('allprim')"
              :label="$translate('allprim') | capitalize"
            >
              <b-select
                v-model="all.allprim"
                v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                :disabled="disabledbool"
                name="allprim"
                :placeholder="$translate('placeholder_select')"
                @input="all.allvar = null"
              >
                <option v-for="optio in $allacciatura" :key="optio.key" :value="optio.key">
                  {{ $translate(optio.key) | capitalize }}
                </option>
              </b-select>
            </b-field>
            <template v-if="$allacciatura.find(temp => temp.key === all.allprim) != undefined">
              <b-field
                v-if="all.allprim && $allacciatura.find(temp => temp.key === all.allprim).variant.length != 0"
                :type="{ 'is-danger': errors.has('allvar') }"
                :message="errors.first('allvar')"
                :label="$translate('allvar') | capitalize"
              >
                <b-select
                  v-model="all.allvar"
                  v-validate="{ required: (mod.custom && !mod.from_duna_catalog) || orderInfoMandatory }"
                  :disabled="disabledbool"
                  type="textarea"
                  name="allvar"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="x in $allacciatura.find(temp => temp.key === all.allprim).variant"
                    :key="x.key"
                    :value="x.key"
                  >
                    {{ $translate(x.key) | capitalize }}
                  </option>
                </b-select>
              </b-field>
            </template>
            <template v-if="!isSimplified && orderbool">
              <b-field horizontal>
                <strong>{{ $translate('left_foot') }}</strong>
                <strong>{{ $translate('right_foot') }}</strong>
              </b-field>
              <b-field
                v-if="
                  all.allprim == 'allacciatura0' &&
                    (all.allvar == 'allacciatura0var1' ||
                      all.allvar == 'allacciatura0var2' ||
                      all.allvar == 'allacciatura0var3' ||
                      all.allvar == 'allacciatura0var4')
                "
                :label="$translate('number_occh')"
                horizontal
              >
                <b-input
                  v-model="all.occh_sx"
                  type="number"
                  :placeholder="$translate('placeholder_numeric')"
                  :disabled="disabledbool"
                />
                <b-input
                  v-model="all.occh_dx"
                  type="number"
                  :placeholder="$translate('placeholder_numeric')"
                  :disabled="disabledbool"
                />
              </b-field>
              <b-field
                v-if="all.allprim == 'allacciatura0' && all.allvar == 'allacciatura0var4'"
                :label="$translate('number_ganc')"
                horizontal
                :placeholder="$translate('placeholder_select')"
              >
                <b-input v-model="all.gan_sx" type="number" :placeholder="$translate('placeholder_numeric')" />
                <b-input v-model="all.gan_dx" type="number" :placeholder="$translate('placeholder_numeric')" />
              </b-field>
              <b-field
                v-if="
                  all.allprim == 'allacciatura1' &&
                    (all.allvar == 'allacciatura1var1' ||
                      all.allvar == 'allacciatura1var2' ||
                      all.allvar == 'allacciatura1var3' ||
                      all.allvar == 'allacciatura1var4' ||
                      all.allvar == 'allacciatura1var5' ||
                      all.allvar == 'allacciatura1var6' ||
                      all.allvar == 'allacciatura1var7' ||
                      all.allvar == 'allacciatura1var8' ||
                      all.allvar == 'allacciatura1var9')
                "
                :label="$translate('number_velc')"
                horizontal
              >
                <b-input v-model="all.vel_sx" type="number" :placeholder="$translate('placeholder_numeric')" />
                <b-input v-model="all.vel_dx" type="number" :placeholder="$translate('placeholder_numeric')" />
              </b-field>
              <b-field
                v-if="
                  all.allprim == 'allacciatura1' &&
                    (all.allvar == 'allacciatura1var1' ||
                      all.allvar == 'allacciatura1var2' ||
                      all.allvar == 'allacciatura1var3' ||
                      all.allvar == 'allacciatura1var4' ||
                      all.allvar == 'allacciatura1var5' ||
                      all.allvar == 'allacciatura1var6' ||
                      all.allvar == 'allacciatura1var7' ||
                      all.allvar == 'allacciatura1var8' ||
                      all.allvar == 'allacciatura1var9')
                "
                :label="$translate('long_velc')"
                horizontal
              >
                <b-input v-model="all.longvel_sx" type="number" :placeholder="$translate('placeholder_numeric')" />
                <b-input v-model="all.longvel_dx" type="number" :placeholder="$translate('placeholder_numeric')" />
              </b-field>
              <b-field
                v-if="
                  all.allprim == 'allacciatura1' &&
                    (all.allvar == 'allacciatura1var1' ||
                      all.allvar == 'allacciatura1var2' ||
                      all.allvar == 'allacciatura1var3' ||
                      all.allvar == 'allacciatura1var4' ||
                      all.allvar == 'allacciatura1var5' ||
                      all.allvar == 'allacciatura1var6' ||
                      all.allvar == 'allacciatura1var7' ||
                      all.allvar == 'allacciatura1var8' ||
                      all.allvar == 'allacciatura1var9')
                "
                :label="$translate('lar_velc')"
                horizontal
              >
                <b-input v-model="all.larvel_sx" type="number" :placeholder="$translate('placeholder_numeric')" />
                <b-input v-model="all.larvel_dx" type="number" :placeholder="$translate('placeholder_numeric')" />
              </b-field>
              <b-field v-if="all.allprim == 'allacciatura1'" :label="$translate('allacciatura1var9')" horizontal>
                <b-checkbox v-model="all.inv_vel_sx" />
                <b-checkbox v-model="all.inv_vel_dx" />
              </b-field>
              <b-field :label="$translate('Mod') | capitalize" horizontal>
                <b-select
                  v-model="all.matacc_sx"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="optio in availableallacc"
                    :key="optio.id"
                    :value="optio.id"
                    :label="$translateMaterial(optio)"
                  >
                    {{ $translateMaterial(optio) }}
                  </option>
                </b-select>
                <b-select
                  v-model="all.matacc_dx"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="optio in availableallacc"
                    :key="optio.id"
                    :value="optio.id"
                    :label="$translateMaterial(optio)"
                  >
                    {{ $translateMaterial(optio) }}
                  </option>
                </b-select>
              </b-field>
              <b-field v-if="all.matacc_sx || all.matacc_dx" :label="$translate('variant') | capitalize" horizontal>
                <b-select
                  v-if="all.matacc_sx"
                  v-model="all.varacc_sx"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                >
                  <template v-for="optio in availableallacc">
                    <template v-if="optio.id == all.matacc_sx">
                      <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                        {{ $translateMaterialVariant(variant) }}
                      </option>
                    </template>
                  </template>
                </b-select>
                <b-select v-else-if="all.matacc_dx" :disabled="true" :placeholder="$translate('placeholder_select')" />
                <b-select
                  v-if="all.matacc_dx"
                  v-model="all.varacc_dx"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                >
                  <template v-for="optio in availableallacc">
                    <template v-if="optio.id == all.matacc_dx">
                      <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                        {{ $translateMaterialVariant(variant) }}
                      </option>
                    </template>
                  </template>
                </b-select>
              </b-field>
            </template>
            <hr />
          </div>
        </template>
        <template v-if="!isSimplified && orderbool">
          <b-field horizontal>
            <strong>{{ $translate('left_foot') }}</strong>
            <strong>{{ $translate('right_foot') }}</strong>
          </b-field>

          <b-field :label="$translate('var_ling') | capitalize" horizontal>
            <b-select
              v-model="mod.var_ling_sx"
              multiple
              native-size="5"
              :disabled="disabledbool"
              :placeholder="$translate('placeholder_select')"
            >
              <option value="vlecr_med_stop">
                {{ $translate('vlecr_med_stop') }}
              </option>
              <option value="velcr_lat_stop">
                {{ $translate('velcr_lat_stop') }}
              </option>
              <option value="ling_cut">
                {{ $translate('ling_cut') }}
              </option>
              <option value="ling_soff">
                {{ $translate('ling_soff') }}
              </option>
              <option value="ling_rigi">
                {{ $translate('ling_rigi') }}
              </option>
            </b-select>
            <b-select
              v-model="mod.var_ling_dx"
              multiple
              native-size="5"
              :disabled="disabledbool"
              :placeholder="$translate('placeholder_select')"
            >
              <option value="vlecr_med_stop">
                {{ $translate('vlecr_med_stop') }}
              </option>
              <option value="velcr_lat_stop">
                {{ $translate('velcr_lat_stop') }}
              </option>
              <option value="ling_cut">
                {{ $translate('ling_cut') }}
              </option>
              <option value="ling_soff">
                {{ $translate('ling_soff') }}
              </option>
              <option value="ling_rigi">
                {{ $translate('ling_rigi') }}
              </option>
            </b-select>
          </b-field>
        </template>

        <b-button type="is-primary" inverted :disabled="disabledbool" @click="addallcia()">
          {{ $translate('add_allacci') | capitalize }}
          <b-icon icon="plus-circle" size="is-small" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/allacciatura'

export default {
  name: 'Allacciatura',
  props: ['mod', 'availableallacc', 'disabledbool', 'orderbool', 'orderInfoMandatory', 'isSimplified'],
  data() {
    return {}
  },
  //props: {
  //  mod: {
  //    type: Object,
  //    default() {
  //      return {
  //        var_ling_sx: [],
  //        var_ling_dx: []
  //      }
  //    }
  //  },
  //  availableallacc: {
  //    type: Array,
  //    default() {
  //      return []
  //    }
  //  },
  //  disabledbool: {
  //    type: Boolean,
  //    default: true
  //  },
  //  orderbool: {
  //    type: Boolean,
  //    default: false
  //  },
  //  orderInfoMandatory: {
  //    type: Boolean,
  //    default: false
  //  }
  //},
  inject: ['$validator'],
  watch: {
    mod: function() {
      this.addMandatoryAllacci()
    },
    orderInfoMandatory: function() {
      this.addMandatoryAllacci()
    },
  },
  created() {
    this.addMandatoryAllacci()
  },
  methods: {
    addMandatoryAllacci() {
      if (this.mod.allacci == undefined || this.mod.allacci.length == 0) {
        this.mod.allacci = []
        if (this.orderInfoMandatory) {
          this.mod.allacci.push({ allprim: null, allvar: null })
        }
      }
    },
    addallcia() {
      this.mod.allacci.push({ allprim: null, allvar: null })
      this.$forceUpdate()
    },
    removeallcia(index) {
      if (this.orderInfoMandatory) {
        if (this.mod.allacci.length > 1) {
          this.mod.allacci.splice(index, 1)
          for (let i = 0; i < this.mod.allacci.length; i++) {
            this.mod.allacci[i].id = i + 1
          }
        } else {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('at_least_one_variant'),
          })
        }
      } else {
        this.mod.allacci.splice(index, 1)
        for (let i = 0; i < this.mod.allacci.length; i++) {
          this.mod.allacci[i].id = i + 1
        }
      }
    },
  },
}
</script>
